<template>
  <div class="form-view__powered-by">
    Powered by
    <a
      href="https://origem.digital"
      target="_blank"
      title="Origem Flow - gestão de projetos da Origem Digital"
    >
      <Logo
        class="form-view__powered-by-logo"
        alt="Origem Flow - gestão de projetos da Origem Digital"
      />
    </a>
  </div>
</template>
